import request from '@/utils/request'

// 获取首页信息
export function getIndex(params) {
  return request({
    url: '/home/first/page',
    method: 'get',
    params
  })
}
// 获取菜单
export function getMenu(params) {
  return request({
    url: '/home/navigation',
    method: 'get',
    params
  })
}
// 企业简介
export function getDecs(id) {
  return request({
    url: '/home/company/profile/'+id,
    method: 'get',
  })
}
// 页脚内容
export function getFooter() {
  return request({
    url: '/home/bottom/page',
    method: 'get',
  })
}
//获取图片
export function getImgs(id) {
  return request({
    url: '/home/protection/'+id,
    method: 'get',
  })
}
//获取动态
export function getDt(data) {
  return request({
    url: '/home/column/content',
    method: 'post',
    data
  })
}
//获取动态详情
export function getDetail(data) {
  return request({
    url: '/home/contact/detail',
    method: 'post',
    data
  })
}
//获取
export function getStockDetail(data) {
  return request({
    url: '/home/stock/list',
    method: 'post',
    data
  })
}
//获取二级目录
export function getClist(id) {
  return request({
    url: '/home/column/'+id,
    method: 'get',
  })
}

//联系我们
export function getContact(id) {
  return request({
    url: '/home/contact/'+id,
    method: 'get',
  })
}
//投资者保护
export function getProtect(data) {
  return request({
    url: '/home/column/content',
    method: 'post',
    data
  })
}
//员工认证
export function checkPeople(data) {
  return request({
    url: '/home/authent',
    method: 'post',
    data
  })
}
//获取员工
export function getPeoples(data) {
  return request({
    url: '/home/publicity',
    method: 'post',
    data
  })
}
//投诉接口
export function suggest(data) {
  return request({
    url: '/home/complaint/add',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js